// extracted by mini-css-extract-plugin
export default {"container":"styles_container__gtyVu","content":"styles_content__3MwNf","buttons":"styles_buttons__Uupi4","title":"styles_title__L4uaz"};